import React from 'react';
import { Card, Avatar } from 'antd';
import {
    MailOutlined,
    CalendarOutlined,
    InfoCircleOutlined
} from '@ant-design/icons';
import { formatDateTime, formatLeadSource } from '../../../../../utils/functions';
import { getInitials } from '../../../../../utils/helper';

const EnhancedCancelledSubscriptionsCardView = ({
    record,
}) => {
    const cancelledBy = formatLeadSource(record.userEmail);
    const initials = getInitials(cancelledBy);

    const getReasonTitle = (reason, otherReason) => {
        let reasons = "";
        if (reason.ChangedCancelledCRMSoftware === true)
            reasons = "Changed Cancelled CRM Software";
        if (reason.NoLongerUsing3rdPartyLeads === true)
            reasons += "No Longer Using 3rd Party Leads";
        if (reason.NotEnoughLeadsIncoming === true)
            reasons += "Not Enough Leads Incoming";
        if (reason.ServiceNotWorking === true)
            reasons += "Service Not Working";
        if (reason.TooComplicated === true) reasons += "Too Complicated";
        if (reason.TooExpensive === true) reasons += "Too Expensive";
        if (reason.Other === true) reasons += `Other: ${otherReason}`;
        return reasons.trim() === "" ? "-" : reasons;
    };

    return (
        <Card
            hoverable
            className="h-full relative"
            style={{ padding: '16px' }}
        >
            <div className="space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3 overflow-hidden">
                        <Avatar
                            size={48}
                            className="flex-shrink-0 font-semibold text-lg !bg-primary"
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate capitalize" title={cancelledBy}>
                                {cancelledBy || "N/A"}
                            </h3>
                            {record.userEmail && (
                                <div className="flex items-center text-gray-500 text-sm mb-0">
                                    <MailOutlined className="mr-1.5 flex-shrink-0" />
                                    <span className="truncate" title={record.userEmail}>
                                        {record.userEmail}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Details Section */}
                <div className="space-y-3 pt-2">
                    {/* Reason */}
                    <div className="flex items-start justify-between">
                        <span className="text-sm text-gray-600 font-medium flex items-center mt-0.5">
                            <InfoCircleOutlined className="mr-2" />
                            Reason:
                        </span>
                        <span
                            className="text-sm text-gray-700 text-right max-w-[60%]"
                        >{getReasonTitle(record.cancelReasons || {}, record.cancelReasonOther) ?? "-"}</span>
                    </div>

                    {/* Cancelled At */}
                    <div className="flex items-center justify-between border-t border-gray-200 pt-3 mt-3">
                        <span className="text-sm text-gray-600 font-medium flex items-center">
                            <CalendarOutlined className="mr-2" />
                            Cancelled At:
                        </span>
                        <span className="text-sm font-semibold text-gray-900">
                            {formatDateTime(record.createdAt)}
                        </span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedCancelledSubscriptionsCardView;
